/**
 * Helper function for create sst data
 */
const createSSTData = ({ jsonPayload }: { jsonPayload: SstPayload }): Sst => {
    const sst = new Sst();

    // Merge the incoming data INTO the existing sst.jsonPayload
    sst.jsonPayload = {
        ...sst.jsonPayload,
        ...jsonPayload
    };

    return sst;
};

export { createSSTData };
